/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_ReadingInputs */

const en_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading project file...`)
};

const fr_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture du fichier projet...`)
};

const de_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektdatei wird gelesen...`)
};

const it_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettura del file di progetto...`)
};

const ru_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтение файла проекта...`)
};

const es_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo archivo de proyecto...`)
};

const zh_cn2_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在读取项目文件...`)
};

const ja_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト ファイルを読み込んでいます...`)
};

const hi_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइल पढ़ी जा रही है...`)
};

const pt_pt2_load_project_file_status_reading = /** @type {(inputs: Load_Project_File_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lendo o arquivo do projeto...`)
};

/**
* | output |
* | --- |
* | "Reading project file..." |
*
* @param {Load_Project_File_Status_ReadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_reading = /** @type {((inputs?: Load_Project_File_Status_ReadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_ReadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_reading(inputs)
	if (locale === "de") return de_load_project_file_status_reading(inputs)
	if (locale === "it") return it_load_project_file_status_reading(inputs)
	if (locale === "ru") return ru_load_project_file_status_reading(inputs)
	if (locale === "es") return es_load_project_file_status_reading(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_reading(inputs)
	if (locale === "ja") return ja_load_project_file_status_reading(inputs)
	if (locale === "hi") return hi_load_project_file_status_reading(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_reading(inputs)
	return en_load_project_file_status_reading(inputs)
});